const safety = [
    'ABS',
    'Wspomaganie hamowania',
]

const comfort = [
    'Rozsuwane burty',
    'Rozsuwany dach',
    'Tylne drzwi',
    'Tylne światła',
]

export default [...safety,...comfort]
export {
    safety,
    comfort,
}